import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { externalLoanCardSx, externalLoanNestedCardSx } from './externalLoanCardStyles';

const BellicksReviewTabPanel = ({ review }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      ...externalLoanCardSx,
    }}
  >
    <Stack spacing={2}>
      <Typography variant="h6" fontWeight={700}>Bellicks review</Typography>
      <Box sx={{ p: 2, ...externalLoanNestedCardSx }}>
        <Stack spacing={1}>
          <Typography variant="subtitle2" color="text.secondary">Bellicks reference</Typography>
          <Typography fontWeight={700}>{review.reference}</Typography>
          <Typography variant="subtitle2" color="text.secondary">Current stage</Typography>
          <Typography>{review.stage}</Typography>
          <Typography variant="subtitle2" color="text.secondary">Assigned reviewer</Typography>
          <Typography>{review.reviewer}</Typography>
          <Typography variant="subtitle2" color="text.secondary">Status</Typography>
          <Chip label={review.status} color={review.status === 'Approved' ? 'success' : review.status === 'Rejected' ? 'error' : 'warning'} size="small" />
        </Stack>
      </Box>
    </Stack>
  </Paper>
);

export default BellicksReviewTabPanel;
